import type { ReactNode } from 'react';

import type { InGameCurrency } from '#src/__generated__/globalTypes.ts';
import { Boost } from '#src/atoms/icons/Boost.tsx';
import { CurrencyBalance } from '#src/components/balance/CurrencyBalance/index.tsx';
import { isXPCurrency } from '#src/lib/rewards.tsx';
import { inGameCurrencyToRarity } from '#src/lib/scarcity.ts';

type Props = { currency: InGameCurrency; amount: number };

export const InGameCurrencyBalance = ({ currency, amount }: Props) => {
  const rarity = inGameCurrencyToRarity[currency];
  let icon: ReactNode;
  if (isXPCurrency(currency) && rarity) {
    icon = <Boost rarity={rarity} size={2} />;
  }

  return <CurrencyBalance amount={amount} icon={icon} />;
};
